import { window } from "@swa-ui/browser/window";

/**
 * Encrypts data using the provided encrypt function and appends the resulting JWE token
 * as a query parameter to the given URL path.
 *
 * @param {Function} encrypt - The encryption function from EncryptionContext
 * @param {object} dataToEncrypt - The data to encrypt into a JWE token
 * @param {string} path - The base URL path to append the token to
 * @param {string} component - The name of the consuming component for logging
 * @param {string} feature - The feature key used to resolve the JWKS config
 * @param {string} [searchParamName="searchToken"] - The query parameter name for the encrypted token
 * @returns {Promise<string|undefined>} The full URL string with encrypted token, or undefined if encryption fails
 */

export const encryptData = async (
  encrypt,
  dataToEncrypt,
  path,
  component,
  feature,
  searchParamName = "searchToken"
) => {
  const JWEToken = await encrypt?.(dataToEncrypt, component, feature);
  let url;

  if (JWEToken) {
    url = new URL(path, window.location.origin);

    const params = url.searchParams;

    params.append(searchParamName, JWEToken);
  }

  return url?.toString();
};
